<div class="access-card" [class.expanded]="expanded">
  <div class="card-header" (click)="toggleExpanded()">
    <div class="card-title">
      <div class="title-icon" [class.success]="successfullyConnected">
        @if (successfullyConnected) {
          <svg lucideCheck></svg>
        }
        @if (!successfullyConnected && accessType === 'source') {
          <svg lucideMapPin></svg>
        }
        @if (!successfullyConnected && accessType === 'target') {
          <svg lucideLocateFixed></svg>
        }
        @if (!successfullyConnected && accessType === 'failback') {
          <svg lucideRotateCcw></svg>
        }
      </div>
      <div>
        <h3>{{ title }}</h3>
        <div class="card-subtitle">
          <code>{{ subscriptionId }}</code> / <code>{{ region }}</code>
        </div>
      </div>
    </div>
    <div class="card-actions">
      <div class="card-action" (click)="$event.stopPropagation()">
        @if (successfullyConnected) {
          <span class="success-badge"><svg lucideCircleCheck></svg> Connected</span>
        } @else {
          <!-- Access is already working, just missing newer access changes. Keep
          Test Access alongside so the customer can verify after updating. -->
          @if (connectedOnOlderTemplate) {
            <span class="stale-badge"><svg lucideCircleAlert aria-hidden="true"></svg> Out of date</span>
          }
          <button
            class="arpio-button small-button"
            data-cy="test-access-button"
            [disabled]="testing"
            (click)="testButtonClick()"
          >
            @if (testing) {
              <svg lucideLoaderCircle class="lucide-spin"></svg> Testing...
            } @else {
              Test Access
            }
          </button>
        }
      </div>
      @if (expanded) {
        <svg lucideChevronDown class="chevron-icon"></svg>
      } @else {
        <svg lucideChevronRight class="chevron-icon"></svg>
      }
    </div>
  </div>

  @if (!successfullyConnected) {
    <div class="card-body-wrapper" [@slideDown]="expanded ? 'expanded' : 'collapsed'">
      <div class="card-body">
        <p class="instruction-text">
          @if (retryText) {
            <strong class="retry-text">{{ retryText }}</strong>
          }
          Execute the following command to grant {{ uiService.productName }} access to your Azure subscription:
        </p>
        <div class="command-block">
          <button class="copy-btn" [copy-clipboard]="installCommand" (copied)="onCopied()">
            @if (copied) {
              <svg lucideCheck class="copy-check"></svg>
            } @else {
              <svg lucideCopy></svg>
            }
            {{ copied ? 'Copied' : 'Copy' }}
          </button>
          <pre><code>{{ installCommand }}</code></pre>
        </div>
      </div>
    </div>
  }

  @if (successfullyConnected) {
    <div class="card-body-wrapper" [@slideDown]="expanded ? 'expanded' : 'collapsed'">
      <div class="card-body success-body">
        <div class="success-message">
          <svg lucideCircleCheck></svg>
          <span>Access configured successfully</span>
        </div>
      </div>
    </div>
  }
</div>
